import { useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { can, when } from "@/components/crm/helpers";

const KIND = { changed: "modificato", added: "aggiunto", removed: "rimosso" };

function Changes({ d }) {
  return (
    <div className="space-y-1 rounded-md border border-slate-100 bg-slate-50 p-2 text-xs" data-testid="site-history-compare">
      <p className="font-medium text-slate-700">{d.total} differenze · {d.summary.changed} modificate, {d.summary.added} aggiunte, {d.summary.removed} rimosse{d.truncated ? " (mostrate le prime 200)" : ""}</p>
      <ul className="max-h-60 space-y-1 overflow-auto">{d.changes.map((c) => (
        <li key={c.path} className="break-words"><span className="font-mono text-slate-500">{c.path}</span> · {KIND[c.kind]}{c.before != null && <span className="block text-red-700">− {c.before}</span>}{c.after != null && <span className="block text-emerald-700">+ {c.after}</span>}</li>))}</ul>
    </div>);
}

// Site draft versions: compare with the current draft and (owner) restore. Restore never publishes and first saves the current draft.
export function SiteHistory({ tid, site, role }) {
  const api = useApi();
  const [d, setD] = useState(null);
  const [cmp, setCmp] = useState(null);
  const [arm, setArm] = useState(null);
  const load = () => api.get(`/t/${tid}/sites/${site.id}/versions`).then(({ data }) => setD(data)).catch((e) => toast.error(errMsg(e)));
  const compare = (vid) => api.get(`/t/${tid}/sites/${site.id}/versions/${vid}/compare`).then(({ data }) => setCmp({ vid, data })).catch((e) => toast.error(errMsg(e)));
  const restore = async (vid) => {
    try { const { data } = await api.post(`/t/${tid}/sites/${site.id}/versions/${vid}/restore`, { confirm: true, base_updated_at: d.current_updated_at }); toast.success(data.note); setArm(null); setCmp(null); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!d) return <Button variant="outline" className="h-10" onClick={load} data-testid={`site-history-open-${site.id}`}>Storico versioni</Button>;
  return (
    <div className="space-y-2" data-testid={`site-history-${site.id}`}>
      <p className="text-xs text-slate-500">Il ripristino cambia solo la bozza (prima la salva come versione): il sito online resta com'è finché MUSORA non pubblica.</p>
      {!d.items.length && <p className="text-xs text-slate-500">Nessuna versione salvata.</p>}
      <ul className="divide-y divide-slate-100 rounded-md border border-slate-200">{d.items.map((v) => (
        <li key={v.id} className="space-y-2 px-3 py-2 text-sm" data-testid={`site-version-${v.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span>{v.label} <span className="text-xs text-slate-500">· {when(v.created_at)}</span></span>
            <span className="flex gap-2">
              <Button size="sm" variant="outline" onClick={() => compare(v.id)} data-testid={`site-version-compare-${v.id}`}>Confronta con la bozza</Button>
              {can(role, "sites.restore") && (arm === v.id
                ? <Button size="sm" variant="destructive" onClick={() => restore(v.id)} data-testid={`site-version-restore-confirm-${v.id}`}>Conferma ripristino</Button>
                : <Button size="sm" variant="outline" onClick={() => setArm(v.id)} data-testid={`site-version-restore-${v.id}`}>Ripristina</Button>)}
            </span>
          </div>
          {cmp?.vid === v.id && <Changes d={cmp.data} />}
        </li>))}</ul>
    </div>);
}
